import { useMemo } from "react";
import { SelectPrintCard } from "./select-print-card";
import "./item-select.print.scss";

type ProductsResponse = {
  products: {
    productNameId: string,
    productName: string,
    productImagePath?: string,
    productDescription?: string,
  }[],
}


type Props = {
  productList: ProductsResponse['products'],
  selectId: string,
  callback: (id: string) => void,
  hidden?: boolean,
}

export const PrintItemSelect = (props: Props) => {
  const {
    productList,
    selectId,
    callback,
    hidden,
  } = props;
  const list = useMemo(() => {
    const obj: {[key: string]: (typeof productList[0])} = {};
    productList.forEach((v) => obj[v.productNameId] = v);
    return obj;
  }, [productList]);

  const selectItem = useMemo(() => {
    const target = list[selectId];
    return target ?? null;
  }, [list, selectId]);

  return (
    <div className="search_print_order order_select">
      <div className="bottom_border_header search_print_order__header">
        商品選択
      </div>
      <div className="search_print_order__select_order">
        {productList.map((data, i) => (
          <SelectPrintCard
            key={`print_item_${data.productNameId}_${i}`}
            data={data}
            callback={(info) => callback(info)}
            isSelect={data.productNameId === selectId}
          />
        ))}
      </div>
    </div>
  )
}